import type {
  SVGAttachment,
  SVGLine,
  SVGMatrixRow,
  SVGSourceData,
} from "./svg-config";
import { PageConfig } from "../../components/content-blocks/forms/customer-form-types";

interface GetGenericSVGLinesProps {
  data: SVGSourceData;
  page: PageConfig;
}

export function getGenericSVGLines({
  data,
  page,
}: GetGenericSVGLinesProps): SVGLine[] {
  const svgLines: SVGLine[] = [];
  for (const question of page.questions) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const text = (data as any)[question.name];

    let label = question.title;
    label = label.replace(/\n/g, " ").replace(/ {2}/g, "");
    if (label.length > 15) {
      label = `${label.substring(0, 15)}...`;
    }

    if (Array.isArray(text)) {
      if (question.type === "file") {
        const files = text as SVGAttachment[];
        let index = 0;
        for (const file of files) {
          const thisLabel = `${label}${index ? ` ${index}` : ""}`;
          svgLines.push({ label: thisLabel, text: file.name });
          index += 1;
        }
      } else if (question.type === "matrixdynamic") {
        let compositeIndex = 1;
        const matrix = text as SVGMatrixRow[];
        for (const line of matrix) {
          let compositeText = "";
          for (const attr of Object.keys(line)) {
            if (compositeText) {
              compositeText = `${compositeText}, `;
            }
            compositeText = `${compositeText}${attr}: ${line[attr]}`;
          }
          svgLines.push({
            label: compositeIndex.toString(),
            text: compositeText,
          });
          compositeIndex += 1;
        }
      }
    } else if (question.type === "signaturepad") {
      svgLines.push({ src: data.signed });
    } else if (text) {
      svgLines.push({ label, text });
    }
  }

  if (svgLines.length !== 0) {
    svgLines.unshift({ heading: page.title });
  }

  return svgLines;
}
